import alpha from './alpha'
import dev from './dev'
import local from './local'
import real from './real'
import stage from './stage'
import test from './test'

export default ((process.env['REACT_APP_PROFILE'] || process.env['NEXT_PUBLIC_PROFILE']) === 'local'
    ? local
    : (process.env['REACT_APP_PROFILE'] || process.env['NEXT_PUBLIC_PROFILE']) === 'dev' ||
        (process.env['REACT_APP_PROFILE'] || process.env['NEXT_PUBLIC_PROFILE']) === 'storybook'
      ? dev
      : (process.env['REACT_APP_PROFILE'] || process.env['NEXT_PUBLIC_PROFILE']) === 'alpha'
        ? alpha
        : (process.env['REACT_APP_PROFILE'] || process.env['NEXT_PUBLIC_PROFILE']) === 'test'
          ? test
          : (process.env['REACT_APP_PROFILE'] || process.env['NEXT_PUBLIC_PROFILE']) === 'beta'
            ? stage
            : real) as typeof real
